import { inViewport } from '@/helpers';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component({
  name: 'CmgMemberRewards',
})
export default class CmgMemberRewards extends Vue {
  shouldShowStickyHeader = false;

  mounted(): void {
    window.addEventListener('scroll', this.onScroll, true);
    this.$services.ui.setAppBlur(true);
    this.$services.ui.setAppPepperVisibility(true);
    this.$services.reward.getRewardOffers().finally(() => {
      this.$services.ui.setAppBlur(false);
      this.$services.ui.setAppPepperVisibility(false);
    });
    this.scrollToHash();
  }

  destroyed(): void {
    window.removeEventListener('scroll', this.onScroll, true);
  }

  get isRewardsOnline(): boolean {
    return this.$appStore.state.featureFlags.orderingStatus?.isRewardsOnline ?? true;
  }

  get isRewardsExchangeOnline(): boolean {
    return this.$appStore.state.featureFlags.orderingStatus?.isRewardsExchangeOnline ?? true;
  }

  get isServiceOnline(): boolean {
    return this.isRewardsOnline && this.isRewardsExchangeOnline && !this.$appStore.state.reward.unreachable;
  }

  onScroll(): void {
    if (this.isServiceOnline) {
      this.shouldShowStickyHeader = !inViewport(this.$refs.loyaltyProgressHeader as Element);
    }
  }

  private scrollToHash() {
    if (!this.$route.hash) {
      return;
    }

    const routeHash: string = this.$route.hash.replace('#', '');
    const componentEl = document.getElementById(routeHash);

    if (componentEl) {
      this.$nextTick(() => componentEl.scrollIntoView());
    }
  }
}
